import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { InjuredPersonForm } from './injured-person-form';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import { RoadControlsForm } from '../../../../common/components/road-controls-set/road-controls.form';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class EventForm extends RoadControlsForm {
  constructor() {
    super({
      provideDateRangeDescription: new FormControl(false),
      eventLocation: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      eventDescription: new FormControl(null, [Validators.required]),
      geometry: new FormControl(null, environment.production ? Validators.required : []),
      eventStartDate: new FormControl(null, Validators.required),
      eventStartTime: new FormControl(null, Validators.required),
      estimatedDamageValue: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.maxLength(255)),
      description: new FormControl(null, [Validators.maxLength(5000), Validators.required]),
      injuredDataSameAsApplicant: new FormControl(false, { nonNullable: true }),
      damageType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      servicesNotifiedAboutEvent: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      additionalInformation: new FormControl(null, [Validators.maxLength(5000)])
    });
    this.injuredDataSameAsApplicantChange(false);
  }

  public get servicesNotifiedAboutEventDesc(): FormControl | null {
    return this.get('servicesNotifiedAboutEventDesc') as FormControl | null;
  }

  public servicesNotifiedAboutEventChange(v: string): void {
    if (v === 'Inne służby') {
      this.addControl('servicesNotifiedAboutEventDesc', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('servicesNotifiedAboutEventDesc');
    }
  }

  public get injuredPersonForm(): InjuredPersonForm | null {
    return this.get('injuredPerson') as InjuredPersonForm | null;
  }

  public injuredDataSameAsApplicantChange(v: boolean): void {
    if (v) {
      this.removeControl('injuredPerson');
    } else {
      this.addControl('injuredPerson', new InjuredPersonForm());
    }
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public get eventStartDate(): FormControl {
    return this.get('eventStartDate') as FormControl;
  }

  public get eventStartTime(): FormControl {
    return this.get('eventStartTime') as FormControl;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      dateRangeDescription: this.value?.dateRangeDescription || null,
      injuredWasDesc: this.value?.injuredWasDesc || null,
      servicesNotifiedAboutEventDesc: this.value?.servicesNotifiedAboutEventDesc || null,
      ...this.injuredPersonForm?.toWriteModel()
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);

    this.eventStartDate?.setValue(value?.eventStartDate || null);
    this.eventStartTime?.setValue(value?.eventStartTime || null);

    this.injuredDataSameAsApplicantChange(!!value?.injuredDataSameAsApplicant);
    this.injuredPersonForm?.patchFormValues(value);

    this.servicesNotifiedAboutEventChange(value?.servicesNotifiedAboutEvent || '');
    this.servicesNotifiedAboutEventDesc?.setValue(value?.servicesNotifiedAboutEventDesc || '');
  }
}
